const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Slack Integrations Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('SlackIntegrate', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/v3/:resource/:subresource', null, {
    create: {params: {resource: 'slackintegrate', subresource: ''}, method: 'POST', isArray: false},
    createEddy: {params: {resource: 'slack', subresource: 'eddy'}, method: 'POST', isArray: false},
    uninstall: {params: {resource: 'slackintegrate', subresource: 'uninstall'}, method: 'POST', isArray: false}
  });
}]);